import { images } from '../theme'

// export const API_URL: string = 'https://api.beta.xn--szukado-sjb.pl';
export const API_URL: string = 'https://beta.szukadło.pl'
// process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://api.home.klyta.it'

export const SHOW_DEV_TOOLS: boolean = false

export const WEB_PAGE_NAME: string = 'Szukadło'
export const WEB_PAGE_BASIC_TYPE: string = 'website'
export const WEB_PAGE_DESCRIPTION: string = 'Wszystko czego szukasz!'
export const WEB_PAGE_LOCALE: string = 'pl_PL'
export const WEB_PAGE_META_IMAGE: string = images.logo
export const WEB_PAGE_KEYWORDS: string = 'Zdjęcia, photos'
export const WEB_PAGE_AUTHOR: string = 'Klyta.it'

export const AUTH_COOKIE_NAME: string = 'auth'

export const SEARCH_QUERY_PARAM: string = 'q'
